// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__3qVrH","switch__checkbox":"ToggleSwitch_switch__checkbox__FESjb","switch__slider":"ToggleSwitch_switch__slider__TgyBu"};